import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { fileTypeToIconMap } from '../FileUploadStep';
import type { File } from 'types/File';

type MemoryFilesTabProps = { files: File[] };

function MemoryFilesTab({ files }: MemoryFilesTabProps) {
  return (
    <Grid container justifyContent='center' gap={2}>
      {files.map((item) => (
        <Grid
          item
          container
          alignItems='center'
          gap={2}
          xs={12}
          bgcolor={(theme) => theme.palette.bgGray.main}
          borderRadius='10px'
          padding={2}
        >
          <Box>{fileTypeToIconMap[item.attributes.fileType]}</Box>
          <Box>
            <Typography>{item.attributes.fileName}</Typography>
            <Typography variant='body2'>{`${item.attributes.fileSize} kb`}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default MemoryFilesTab;
